<template>
  <div class="users-sell-out">
    <div class="totals">
      <span>
        Total de SDZ consolidado: {{ totalSeedz !== null ? `${$currencyFormat(totalSeedz)} SDZ` : 'Processando...' }}
      </span>
      <span
        v-if="isComercial && isPBI66613FlagActive"
        class="ml-3"
      >
        Total de SDZ com aceleradores: {{ totalAcceleratorSeedz !== null ? `${$currencyFormat(totalAcceleratorSeedz)} SDZ` : 'Processando...' }}
      </span>
      <span
        v-if="showParticipantsProportion"
        class="ml-3"
      >
        Porcentagem equipe: {{ participantsProportion }}%
      </span>
      <span
        v-if="showSellerProportion"
        class="ml-3"
      >
        Porcentagem vendedor: {{ apportionment.ownerProportion }}%
      </span>
    </div>
    <div class="title">
      <span
        v-if="apportionmentType"
      >{{ apportionmentType === 'seller' ? 'Vendedor' : participantTitle }}</span>
    </div>

    <AppInfiniteScroll
      ref="infiniteScroll"
      :loading="loading"
      :last-items="isLastPage"
      @nextPage="nextPage"
      max-height="400px"
    >
      <v-data-table
        :headers="headersParticipants"
        :items="participants"
        :expand="false"
        item-key="_id"
        max-height="250px"
        hide-actions
      >
        <template v-slot:items="participant">
          <tr
            @click="showProducts(participant)"
            style="cursor: pointer;"
          >
            <td>{{ participant.item.name }}</td>
            <td>{{ participant.item.role }}</td>
            <td v-if="showTotalAcceleratorSDZ && isComercial">
              {{ participant.item.totalAcceleratorSeedz }}
            </td>
            <td>{{ participant.item.totalSeedz }}</td>
            <td style="width: 40px;">
              <v-icon style="cursor: pointer;">
                {{ participant.expanded ? 'expand_less' : 'expand_more' }}
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expand="participant">
          <ParticipantsProducts
            v-if="participant.item.products && participant.item.products.length"
            :products="participant.item.products"
            :role="role"
            :loading="participant.item.loadingProducts"
            :hasTotalAcceleratorSDZ="showTotalAcceleratorSDZ"
          />
          <div
            v-else
            class="product-details"
          >
            <AppLoadingIcon
              v-if="participant.item.loadingProducts"
              color="#CCCCCC"
            />
            <span v-else>Nenhum resultado encontrado</span>
          </div>
        </template>
      </v-data-table>
    </AppInfiniteScroll>
  </div>
</template>
<script>
import AppInfiniteScroll from '@/components/ui/AppInfiniteScroll'
import AppLoadingIcon from '@/components/ui/AppLoadingIcon'
import ParticipantsProducts from './ParticipantsProducts'
import {
  getParticipantsDetails,
  getParticipantsDetailsWithAccelerator,
  getProductsSelloutDetails,
  getProductsAcceleratorsSelloutDetails,
  getParticipantsTotalsInCampaign,
} from '@/services/containers/partners/campaigns'
import EventBus from '@/helpers/eventbus'
import { ANALYTICS_EVENTS } from '@/helpers/consts'

export default {
  name: 'UsersSellOut',
  components: {
    AppInfiniteScroll,
    AppLoadingIcon,
    ParticipantsProducts
  },
  props: {
    campaignId: {
      type: String,
      required: true
    },
    hideTotalSDZ: {
      type: Boolean,
      default: false
    },
    hideTotalSDZWithAccelerator: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      required: true,
      validator: (value) => {
        return ['legal', 'comercial'].includes(value)
      }
    },
    apportionmentType: {
      type: String,
      default: ''
    },
    apportionment: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      loading: false,
      participants: [],
      participantsProducts: [],
      totalSeedz: null,
      totalAcceleratorSeedz: null,
      paginagion: {
        page: 1,
        itensPorPage: 10,
        totalCount: null,
        pageCount: null
      },
    }
  },
  async created() {
    this.getParticipants()
    this.getParticipantsTotals()
  },
  computed: {
    isPBI66613FlagActive() {
      return this.$isFeatureFlagActive('PBI66613-calculo_apuracao')
    },
    isLegal() {
      return this.role === 'legal'
    },
    isComercial() {
      return this.role === 'comercial'
    },
    isLastPage() {
      return !!(this.paginagion.totalCount
        && this.paginagion.page > this.paginagion.pageCount)
    },
    showTotalAcceleratorSDZ() {
      if (this.isComercial) {
        if (this?.apportionment?.apportionmentType === 'participant') return true
        if (this?.apportionment?.apportionmentType === 'seller' && this?.apportionmentType === 'seller') return true
      }
      return false
    },
    headersParticipants() {
      return [
        {
          text: 'Nome',
          value: 'name',
          sortable: false,
          show: true
        },
        {
          text: 'Função',
          value: 'role',
          sortable: false,
          show: true
        },
        {
          text: 'Bônus Seedz Aceleradores',
          value: 'totalAcceleratorSDZ',
          sortable: false,
          show: this.showTotalAcceleratorSDZ
        },
        {
          text: 'Total SDZ',
          value: 'totalSDZ',
          sortable: false,
          show: true
        },
        {
          text: '',
          value: '',
          sortable: false,
          with: '72px',
          show: true // precisa dessa coluna vazia porque é onde exibe o ícone de expandir
        }
      ].filter(header => header.show)
    },
    participantsProportion() {
      return this?.apportionment?.rules.reduce((acc, curr) => {
        return acc + curr.proportion
      }, 0)
    },
    showParticipantsProportion() {
      if (!this?.apportionment?.visibleToSeller) return false
      return this?.apportionment && !this?.apportionmentType || this?.apportionmentType === 'participant'
    },
    showSellerProportion() {
      return this?.apportionment && !this?.apportionmentType || this?.apportionmentType === 'seller'
    },
    participantTitle() {
      return this?.apportionment?.visibleToSeller ? 'Equipe' : ''
    }
  },
  methods: {
    async getParticipants() {
      try {
        if (this.loading || this.isLastPage) {
          return
        }
        this.loading = true
        const method = this.isLegal
          ? getParticipantsDetails
          : getParticipantsDetailsWithAccelerator

        const query = (this?.apportionment?.visibleToSeller ? `&apportionmentType=${this?.apportionmentType}` : '')

        const response = await method(
          this.campaignId,
          this.paginagion.page,
          query
        )

        this.participants.push(...response.data)
        this.paginagion.page++
        this.paginagion.totalCount = response.totalCount
        this.paginagion.pageCount = response.pageCount

        this.$emit('totalUsers', response.totalCount)

      } catch (error) {
        if (error?.response?.status) {
          this.$toast('Erro ao buscar participantes', 'red')
        }
      } finally {
        this.page++
        this.loading = false
      }
    },
    async getParticipantsTotals() {
      try {
        if (this.paginagion.page !== 1) return
        this.loading = true
        const hasNotAccelerator = this.isLegal
        const { data } = await getParticipantsTotalsInCampaign(this.campaignId, { hasNotAccelerator })

        this.totalSeedz = data?.totalSeedz
        this.totalAcceleratorSeedz = data?.totalAcceleratorSeedz

      } catch (error) {
        if (error?.response?.status) {
          this.$toast('Erro ao buscar totais de participantes', 'red')
        }
      } finally {
        this.loading = false
      }
    },
    async getProductsDetails(participant) {
      try {
        if (participant.products) return

        this.$set(participant, 'loadingProducts', true)
        const method = this.isLegal
          ? getProductsSelloutDetails
          : getProductsAcceleratorsSelloutDetails

        // Aqui não tem necessidade de add reatividade
        participant.products = await method(this.campaignId, participant._id)

      } catch (error) {
        this.$toast('Erro ao buscar produtos', 'red')

      } finally {
        participant.loadingProducts = false
      }
    },
    async showProducts(participants) {
      participants.expanded = !participants.expanded
      participants.products = await this.getProductsDetails(participants.item)
    },
    nextPage() {
      EventBus.$emit(ANALYTICS_EVENTS.track.scrollUsersSellOut)
      this.getParticipants()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .users-sell-out
    .totals
      background-color #f5f5f5
      padding 10px 20px
      color: #868E96
      font-weight 500
      font-size 14px

    ::v-deep .title
      font-size: 16px;
      color: #3E6873;
      padding: 16px 0 0 16px;

    .product-details
      min-height 100px
      display flex
      justify-content center
      align-items center
</style>
